import { createApp } from '@app/adapters/create-app'

import LockLedgerProgress from '@app/application/admin/special-actions/lock-ledger-progress-checker'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='lock-ledgers-progress']").each(function () {
    createApp(LockLedgerProgress, {
      channelName: $(this).data('messagebus-channel'),
      lastChannelId: $(this).data('messagebus-last-id'),
      initialProgress: $(this).data('initial-progress'),
      initialRemainingCount: $(this).data('initial-remaining-count'),
    }).mount(this)
  })
})
